<template>
  <div class="homeArticle">
    <div class="homeArticleContainer HomeContainer">
      <!-- default-active 和 index 都必须为string -->
      <el-menu
        :default-active="defaultActive"
        :unique-opened="true"
        background-color="#fff"
        text-color="#333"
        active-text-color="#EE8159"
        @select="getArticle"
        style="overflow: hidden"
      >
        <!-- @open="openMenu" -->

        <el-submenu
          v-for="type_item of articleTypeList"
          :key="type_item.title"
          :index="type_item.title"
        >
          <span slot="title">{{ type_item.title }}</span>
          <el-menu-item
            v-for="article of type_item.children"
            :key="article.id"
            :index="article.id.toString()"
            >{{ article.title }}</el-menu-item
          >
        </el-submenu>
      </el-menu>
      <div class="article">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>{{ l(article.type) }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ article.title }}</el-breadcrumb-item>
        </el-breadcrumb>
        <div v-html="article.content" style="margin-top: 25px"></div>
      </div>
    </div>
  </div>
</template>

<script>
import tableMixin from "@/assets/js/tableMixin";

export default {
  name: "HomeHelp",
  mixins: [tableMixin],
  data() {
    return {
      articleTypeList: [
        { title: this.l("平台规则"), children: [] },
        { title: this.l("操作指南"), children: [] },
        { title: this.l("常见问题"), children: [] },
        { title: this.l("关于我们"), children: [] },
        { title: this.l("锻造标准"), children: [] },
      ],
      article: {},
      defaultActive: "",
    };
  },
  created() {
    this.getArticleList();
    if (this.$route.query.key) {
      this.getArticleByKey(this.$route.query.key);
    }
  },
  methods: {
    getArticleList() {
      this.axios
        .get("/api/article/", {
          params: {
            group: 1,
            // type: this.articleTypeList.map((type) => type.title).join(","),
            size: 999,
            page: 1,
          },
        })
        .then((data) => {
          this.articleTypeList.forEach((group) => {
            group.children.push(
              ...data.results.filter((article) => this.l(article.type) == group.title)
            );
          });
          //从总入口进入则打开第一篇文章
          if (!this.$route.query.key) {
            this.getArticle();
          }
        });
    },
    openMenu(index, index_path) {
      //点击父级后自动选中第一个子级
      // console.log(index, index_path);
      var articleType = this.articleTypeList.find(
        (item) => item.title == index
      );
      if (articleType && articleType.children && articleType.children[0]) {
        this.getArticle(articleType.children[0].id);
      }
    },
    getArticle(target_id) {
      if (!target_id) target_id = this.articleTypeList[0].children[0].id;
      this.defaultActive = target_id.toString();
      this.axios.get(`/api/article/${target_id}/`).then((data) => {
        this.article = data;
      });
    },
    getArticleByKey(key) {
      this.axios
        .get(`/api/article/details/`, {
          params: {
            key,
          },
        })
        .then((data) => {
          this.article = data;
          this.defaultActive = this.article.id.toString();
        });
    },
  },
};
</script>


<style scoped lang="scss">
.homeArticle {
  padding-top: 15px;
  // background: #fff;
  .homeArticleContainer {
    // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    display: flex;
    padding: 20px 0;
    align-items: stretch;
    min-height: 600px;
    background: #fff;
    .el-menu {
      width: 200px;
      flex-shrink: 0;
      box-sizing: border-box;
      border: none;
    }
    .article {
      flex-grow: 1;
      box-sizing: border-box;
      padding: 0 20px;
      border-left: 1px solid $borderColor;
    }
  }
}
</style>

